module.exports = __webpack_public_path__ + "static/img/whatAppLogo1.9ff29c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/whatAppLogo1.png
// module id = /PFK
// module chunks = 29